import { Pipe, PipeTransform } from '@angular/core';
import { AltitudeValueDto } from '@flyfreely-portal-ui/flyfreely';

@Pipe({
    name: 'formatAltitudeValue'
})
export class FormatAltitudeValuePipe implements PipeTransform {
    transform(value: AltitudeValueDto, defaultValue: string): string {
        return value?.height == null ||
            (value.height === 0 && defaultValue === 'SFC')
            ? defaultValue
            : `${value.height} ${value.units} ${value.datum}`;
    }
}
